import { render, staticRenderFns } from "./AllActivities.vue?vue&type=template&id=d700c9ac&scoped=true"
import script from "./AllActivities.vue?vue&type=script&lang=js"
export * from "./AllActivities.vue?vue&type=script&lang=js"
import style0 from "./AllActivities.vue?vue&type=style&index=0&id=d700c9ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d700c9ac",
  null
  
)

export default component.exports